const config = {
  nonprod: {
    idvaasUrl: "https://sit.idvaas.worldreachsoftware.com/idvaasapi/",
    language: "en-CA"
  },
  prod: {
    idvaasUrl: "https://uk.idvaas.worldreachsoftware.com/idvaasapi/",
    language: "en-CA"
  }
};

const environment = process.env.REACT_APP_ENV || (process.env.NODE_ENV === 'production' ? 'prod' : 'nonprod');

export default config[environment];